export type EmailBodyFormat = "plain" | "html";

export function normalizeEmailBodyFormat(value: string | null | undefined): EmailBodyFormat {
  if (value === "html") return "html";
  return "plain";
}
